import { waitForMs } from '../../../helpers';

export default () => {
  $(`.inblogarea__inhouse-button`).on('click', onModelOpen);
  $('.inhouse-training-modal-dialog__close-button').on('click', onModalClose);
  $('.inhouse-training-modal').on('click', function (e: Event) {
    $(e.target).hasClass('inhouse-training-modal') && onModalClose();
  });
};

export async function onModelOpen() {
  const modal = $('#requestDateModal');
  const modalTitle = $(this).data('modal-title');

  modal
    .attr('data-form-type', $(this).data('form-type'))
    .attr('data-modal-title', modalTitle)
    .attr('data-module-id', $(this).data('module-id'))
    .find('.inhouse-training-modal-dialog__title')
    .text(modalTitle);

  if ($(this).attr('data-event-id')) {
    $('#InhouseContactForm select[name=contact_teamsize]').hide();
  } else {
    $('#InhouseContactForm select[name=contact_teamsize]').show();
    modal.removeAttr('data-event-id');
  }

  modal.show();

  await waitForMs(10);

  modal.addClass('show');
}

export async function onModalClose() {
  const modal = $('.inhouse-training-modal');
  modal.removeClass('show');

  await waitForMs(300);

  modal.hide();
}
